const fakeData2 = [
  {
    avatar: "/static/user/user-1.png",
    name: "Zachary Gomez",
    username: "zachary-gomez",
    email: "zachary-gomez@gmail.com",
    role: "Editor",
  },
  {
    avatar: "/static/user/user-2.png",
    name: "Amanda Montgomery",
    username: "amanda-montgomery",
    email: "montgomery@ya.com",
    role: "Subscriber",
  },
  {
    avatar: "/static/user/user-3.png",
    userAvatar: "/static/user/user-2.png",
    name: "Lester Holland",
    username: "zlester-holland",
    email: "lester75@gmail.com",
    role: "Subscriber",
  },
  {
    avatar: "/static/user/user-4.png",
    userAvatar: "/static/user/user-2.png",
    name: "Max Allison",
    username: "max-allison",
    email: "max-allison@pochta.io",
    role: "Subscriber",
  },
  {
    avatar: "/static/user/user-5.png",
    userAvatar: "/static/user/user-2.png",
    name: "Richard Gregory",
    username: "r.gregory",
    email: "gregory@gmail.com",
    role: "Subscriber",
  },
  {
    avatar: "/static/user/user-6.png",
    userAvatar: "/static/user/user-2.png",
    name: "Clifford Caldwell",
    username: "clifford-caldwell",
    email: "clifford-c@gmail.com",
    role: "Author",
  },
  {
    avatar: "/static/user/user-3.png",
    userAvatar: "/static/user/user-2.png",
    name: "Lester Holland",
    username: "zlester-holland",
    email: "lester75@gmail.com",
    role: "Subscriber",
  },
  {
    avatar: "/static/user/user-5.png",
    userAvatar: "/static/user/user-2.png",
    name: "Richard Gregory",
    username: "r.gregory",
    email: "gregory@gmail.com",
    role: "Subscriber",
  },
  {
    avatar: "/static/user/user-4.png",
    userAvatar: "/static/user/user-2.png",
    name: "Max Allison",
    username: "max-allison",
    email: "max-allison@pochta.io",
    role: "Subscriber",
  },
  {
    avatar: "/static/user/user-6.png",
    userAvatar: "/static/user/user-2.png",
    name: "Zachary Gomez",
    username: "zachary-gomez",
    email: "zachary-gomez@gmail.com",
    role: "Editor",
  },
  {
    avatar: "/static/user/user-2.png",
    userAvatar: "/static/user/user-2.png",
    name: "Zachary Gomez",
    username: "zachary-gomez",
    email: "zachary-gomez@gmail.com",
    role: "Editor",
  },
  {
    avatar: "/static/user/user-1.png",
    userAvatar: "/static/user/user-2.png",
    name: "Zachary Gomez",
    username: "zachary-gomez",
    email: "zachary-gomez@gmail.com",
    role: "Editor",
  },
];

export default fakeData2;
